import getQueryParam from "../../custom_js/get_query_param.js";
import {
  newRelativeUrlWith,
  newRelativeUrlWithout,
} from "../../custom_js/new_relative_url.js";

up.compiler("#up_filter_fresk", function (element, data) {
  const selector = new Choices(element, {
    choices: data.map((e) => {
      let res = {
        value: e.slug,
        label: e.title,
      };
      let freskParam = getQueryParam("fresk", up.fragment.source(element));
      if (freskParam && res.value === freskParam) {
        res["selected"] = true;
      }
      return res;
    }),
    placeholder: true,
    placeholderValue: "Fresque",
    removeItemButton: true,
  });

  element.addEventListener(
    "addItem",
    function (event) {
      up.render({
        url: newRelativeUrlWith("fresk", event.detail.value),
        target: "#animators_list",
        history: true,
        focus: "#up_filter_fresk",
      });
    },
    false
  );

  element.addEventListener(
    "removeItem",
    function () {
      up.render({
        url: newRelativeUrlWithout("fresk"),
        target: "#animators_list",
        history: true,
        focus: "#up_filter_fresk",
      });
    },
    false
  );

  return () => {
    selector.destroy();
  };
});
